import { css, StyleSheet } from 'aphrodite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Viewer1 from '../../assets/viewer.png'
import Viewer2 from '../../assets/Viewer2.png'
import Viewer3 from '../../assets/Viewer3.png'
import Viewer4 from '../../assets/Viewer4.jpg'

import SwiperCore, { Autoplay, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import { Swiper, SwiperSlide } from 'swiper/react'
import UIRating from '../../components/UI/UIRating'
SwiperCore.use([Autoplay])

const styles = StyleSheet.create({
  backgroundImage: {
    position: 'relative',
    width: 100,
    height: 100,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: 50,
  },
  container: {
    display: 'flex',
    width: '100%',
    height: '100px',
    overflow: 'hidden',
    position: 'relative',
  },
  swipe: {
    height: 'auto',
    marginBottom: '3%',
    paddingBottom: 15,
  },
  proDesc: {
    width: '50%',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '20px',
    textAlign: 'center',
    color: '#000000',
    margin: 'auto',
    marginTop: '50px',
    marginBottom: '20px',
  },
  name: {
    width: '50%',
    fontStyle: 'italic',
    fontWeight: 'bold',
    fontSize: '20px',
    letterSpacing: '-0.03em',
    textAlign: 'center',
    margin: 'auto',
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    fontWeight: 700,
    fontSize: '40px',
    marginTop: '30px',
    marginBottom: '30px',
  },
  rating: {
    justifyContent: 'center',
    marginTop: 10,
  },
  star: {
    cursor: 'default',
    zoom: '120%',
  },
})

function ProMember() {
  const { t } = useTranslation('translation')

  return (
    <>
      <div className={css(styles.title)}> {t('pages.testimony.title')}</div>
      <Swiper
        pagination={{ clickable: true }}
        modules={[Pagination]}
        className={css(styles.swipe)}
        autoplay={{ delay: 7500 }}
      >
        <SwiperSlide className={css(styles.swipe)}>
          <div
            className={css(styles.backgroundImage)}
            style={{
              backgroundImage: `url(${Viewer1})`,
              backgroundSize: 'contain',
            }}
          />
          <UIRating
            disabled
            dynamicStyle={styles.rating}
            dynamicStyleStar={styles.star}
          />
          <p className={css(styles.proDesc)}>
            {t('pages.testimony.clientDesc')}
          </p>
          <p
            className={css(styles.name)}
            style={{ color: '#6D7175', marginBottom: '20px' }}
          >
            {t('pages.testimony.clientName')}
          </p>
          <p
            className={css(styles.name)}
            style={{ color: '#6D7175', marginBottom: '20px' }}
          >
            {t('pages.testimony.clientRole')}
          </p>
        </SwiperSlide>
        <SwiperSlide className={css(styles.swipe)}>
          <div
            className={css(styles.backgroundImage)}
            style={{
              backgroundImage: `url(${Viewer2})`,
              backgroundSize: 'contain',
            }}
          />
          <UIRating
            disabled
            dynamicStyle={styles.rating}
            dynamicStyleStar={styles.star}
          />
          <p className={css(styles.proDesc)}>
            {t('pages.testimony.clientDesc2')}
          </p>
          <p
            className={css(styles.name)}
            style={{ color: '#6D7175', marginBottom: '20px' }}
          >
            {t('pages.testimony.clientName2')}
          </p>
          <p
            className={css(styles.name)}
            style={{ color: '#6D7175', marginBottom: '20px' }}
          >
            {t('pages.testimony.clientRole2')}
          </p>
        </SwiperSlide>
        <SwiperSlide className={css(styles.swipe)}>
          <div
            className={css(styles.backgroundImage)}
            style={{
              backgroundImage: `url(${Viewer3})`,
              backgroundSize: 'contain',
            }}
          />
          <UIRating
            disabled
            dynamicStyle={styles.rating}
            dynamicStyleStar={styles.star}
          />
          <p className={css(styles.proDesc)}>
            {t('pages.testimony.clientDesc3')}
          </p>
          <p
            className={css(styles.name)}
            style={{ color: '#6D7175', marginBottom: '20px' }}
          >
            {t('pages.testimony.clientName3')}
          </p>
          <p
            className={css(styles.name)}
            style={{ color: '#6D7175', marginBottom: '20px' }}
          >
            {t('pages.testimony.clientRole3')}
          </p>
        </SwiperSlide>
        <SwiperSlide className={css(styles.swipe)}>
          <div
            className={css(styles.backgroundImage)}
            style={{
              backgroundImage: `url(${Viewer4})`,
              backgroundSize: 'cover',
            }}
          />
          <UIRating
            disabled
            dynamicStyle={styles.rating}
            dynamicStyleStar={styles.star}
          />
          <p className={css(styles.proDesc)}>
            {t('pages.testimony.clientDesc4')}
          </p>
          <p
            className={css(styles.name)}
            style={{ color: '#6D7175', marginBottom: '20px' }}
          >
            {t('pages.testimony.clientName4')}
          </p>
          <p
            className={css(styles.name)}
            style={{ color: '#6D7175', marginBottom: '20px' }}
          >
            {t('pages.testimony.clientRole4')}
          </p>
        </SwiperSlide>
      </Swiper>
    </>
  )
}

export default ProMember
